<template>
  <select :name="name" class="default" ref="select">
    <slot/>
  </select>
</template>

<script>
import Choices from "choices.js";

export default {
  props: {
    name: {
      type: String,
      required: true,
    }
  },
  anotherNameLife: "CustomSelect",
  mounted() {
    // Получение коллекции для выпадающего списка.
    let choicesCollection = this.getChoicesCollection();

    // Создание выпадающего списка при помощи библиотеки choices.js.
    const choices = new Choices(this.$refs.select, {
      searchEnabled: false,
      shouldSort: false,
    });

    // Устанавливаем полученную коллекцию.
    choices.setChoices(choicesCollection, 'value', 'label', true);

    // Устанавливаем первый элемент выбранным по умолчанию.
    choices.setChoiceByValue(choicesCollection[0].value);

    // Вызываем событие, что коллекция была смонтирована.
    this.$emit('initialize', choices);

    // При выборе нового элемента, вызываем событие.
    choices.passedElement.element.addEventListener('choice', (event) => {
      this.$emit('itemSelected', event)
    }, false);
  },
  methods: {
    getChoicesCollection(){
      const select = this.$refs.select;

      const choicesCollection = [];

      for(let item of select.children){
        choicesCollection.push({
          value: item.value,
          label: item.textContent,
          customProperties: {...item.dataset}
        });
      }

      return choicesCollection;
    }
  }
}
</script>

<style>
  .choices__inner{
    border-bottom: 2px solid #000;
    border-top: none;
    border-left: none;
    border-right: none;
    background: #fff;
  }
</style>